import { TenantSubscription } from '../../entities/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleDomain, SecurityModuleName, SecurityRight } from '../security.module';


export enum PortalClientSecurityRight {
    CanAccessJobs = 60000,
    CanAccessKnowledgeBase = 60001,
    CanAccessQuotes = 60006,
    CanAccessSites = 60007,
    ManageSites = 60008,
    ManageActivity = 60002,
    ViewInvoice = 60003,
    RequestNewJob = 60004,
    RequestNewQuote = 60005,
    ManageUsers = 60009,
    ViewJobsInSite = 60010,
    ViewQuotesInSite = 60011,
    ViewInvoicesInSite = 60012,
    ViewInvoicesInJob = 60013,
}

export class PortalClientSecurityModule extends BaseSecurityModule<PortalClientSecurityRight> {

    constructor() {

        super(
            SecurityModuleName.PortalClients,
            [
                { _id: PortalClientSecurityRight.CanAccessJobs, name: 'Access Jobs Board', basic: true },
                { _id: PortalClientSecurityRight.ViewJobsInSite, name: 'View Jobs tab within a site', basic: true },
                { _id: PortalClientSecurityRight.CanAccessQuotes, name: 'Access Quotes Board', basic: true },
                { _id: PortalClientSecurityRight.ViewQuotesInSite, name: 'View Quotes tab within a site', basic: true },
                { _id: PortalClientSecurityRight.CanAccessSites, name: 'Access Sites', basic: true },
                { _id: PortalClientSecurityRight.CanAccessKnowledgeBase, name: 'Access Knowledge Base', basic: true },
                { _id: PortalClientSecurityRight.ViewInvoice, name: 'Access Invoices Board', basic: true },
                { _id: PortalClientSecurityRight.ViewInvoicesInSite, name: 'View Invoices tab within a site', basic: true },
                { _id: PortalClientSecurityRight.ViewInvoicesInJob, name: 'View Invoices tab within a job', basic: true },
                { _id: PortalClientSecurityRight.ManageActivity, name: 'Create & Edit Activities', basic: false },
                { _id: PortalClientSecurityRight.ManageSites, name: 'Create & Manage Sites', basic: false },
                { _id: PortalClientSecurityRight.RequestNewJob, name: 'Request New Job', basic: false },
                { _id: PortalClientSecurityRight.RequestNewQuote, name: 'Request New Quote', basic: false },
                { _id: PortalClientSecurityRight.ManageUsers, name: 'Manage Users', basic: false },
            ] as SecurityRight<PortalClientSecurityRight>[],
            SecurityModuleDomain.Portals
        );

        this.plan = TenantSubscription.Custom;
    }

}
